var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('kt-panel',[_c('kt-panel-body',[_c('p',{staticClass:"font-weight-bolder text-danger",style:(_vm.alertMessageStyle)},[_vm._v("\r\n                "+_vm._s(_vm.$t('exception.access_denied'))+"\r\n            ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }